export default "__VITE_ASSET__DJASt_m0__"